import axios from "axios";
import store from '@/store'

const api = axios.create({
    method: 'post',
    baseURL: process.env.VUE_APP_API_BASE_URL,
    headers: {
        "x-brand": process.env.VUE_APP_BRAND,
        "x-target": process.env.VUE_APP_TARGET,
        "Content-Type": "application/json",
    },
});

// Per-request, not in the static headers above: cordova's device global only
// exists after deviceready, so a module-load read would bake in "web" forever.
// Known strings the backend's deprecation check can trust -- never user agent.
api.interceptors.request.use(function (config) {
    /* global device */
    config.headers["x-platform"] =
        typeof device !== "undefined" && device.platform
            ? device.platform.toLowerCase()
            : "web";

    return config;
});

api.interceptors.response.use(undefined, function (error) {
    if (error?.response?.status === 402) {
        store.dispatch('wallet/handleError', error, { root: true })
    }

    return Promise.reject(error);
})


export default api;